'use strict';

module.exports = function (ngModule) {
    ngModule.controller('changelogMainCtrl', require('./main'));
}


/** WEBPACK FOOTER **
 ** ./src/changelog/controllers/index.js
 **/